import formatDate from './format-date'
import isValidDateTimeString from './is-valid-datetime-string'

const date = {
  formatDate,
  isValidDateTimeString,
}

export default date
